import React from 'react';
import {Create, SimpleForm} from 'react-admin';
import {CustomToolbar, Grid} from '../../components'
import PollField from "./PollField";
import moment from "moment";

const defaultValue = {
    startDate: new Date(),
    startTime: moment().format('HH:mm')
}
export const PollCreate = props => (
    <Create {...props}>
        <SimpleForm toolbar={<CustomToolbar/>} redirect="list" defaultValue={defaultValue}>
            <Grid container spacing={8}>
                <PollField/>
            </Grid>
        </SimpleForm>
    </Create>
);

export default PollCreate
